import { RouteObject } from 'react-router-dom';
import { Loadable } from '@sib/ui';
import { paths } from '@sidecar/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.projects.root,
    element: <Loadable component={() => import('./pages/ProjectsPage')} />,
    children: [
      {
        path: paths.projects.children.details,
        element: (
          <Loadable component={() => import('./pages/ProjectDetails')} />
        ),
        children: [
          {
            path: paths.projects.details.tab,
            element: (
              <Loadable component={() => import('./pages/ProjectDetails')} />
            ),
          },
        ],
      },
    ],
  },
];
